import React from 'react';

export default ({ color })=>(
	<svg id="Capa_1" style={{"enableBackground":"new 0 0 512 512"}} version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" xmlSpace="preserve" fill={color}>
		<g>
			<g>
				<path d="M256,181c-33.091,0-60,26.909-60,60s26.909,60,60,60s60-26.909,60-60S289.091,181,256,181z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M499.461,211.205l-39.848-6.475c-4.995-19.893-12.847-38.789-23.408-56.411l22.91-32.095&#xD;&#xA;&#x9;&#x9;&#x9;c4.263-5.962,3.589-14.136-1.597-19.321l-42.422-42.422c-5.215-5.2-13.374-5.889-19.321-1.597l-32.095,22.91&#xD;&#xA;&#x9;&#x9;&#x9;c-17.622-10.562-36.519-18.413-56.411-23.408l-6.475-39.848C299.594,5.303,293.339,0,286,0h-60&#xD;&#xA;&#x9;&#x9;&#x9;c-7.339,0-13.594,5.303-14.795,12.539l-6.475,39.848c-19.893,4.995-38.789,12.847-56.411,23.408l-32.095-22.91&#xD;&#xA;&#x9;&#x9;&#x9;c-5.962-4.292-14.15-3.604-19.321,1.597L54.481,96.903c-5.186,5.186-5.859,13.359-1.597,19.321l22.91,32.095&#xD;&#xA;&#x9;&#x9;&#x9;c-10.562,17.622-18.413,36.519-23.408,56.411l-39.848,6.475C5.303,212.406,0,218.661,0,226v60c0,7.339,5.303,13.594,12.539,14.795&#xD;&#xA;&#x9;&#x9;&#x9;l39.848,6.475c4.995,19.893,12.847,38.789,23.408,56.411l-22.91,32.095c-4.263,5.962-3.589,14.136,1.597,19.321l42.422,42.422&#xD;&#xA;&#x9;&#x9;&#x9;c5.171,5.171,13.359,5.83,19.321,1.597l32.095-22.91c17.622,10.562,36.519,18.413,56.411,23.408l6.475,39.848&#xD;&#xA;&#x9;&#x9;&#x9;C212.406,506.697,218.661,512,226,512h60c7.339,0,13.594-5.303,14.795-12.539l6.475-39.848&#xD;&#xA;&#x9;&#x9;&#x9;c19.893-4.995,38.789-12.847,56.411-23.408l32.095,22.91c5.947,4.233,14.106,3.574,19.321-1.597l42.422-42.422&#xD;&#xA;&#x9;&#x9;&#x9;c5.186-5.186,5.859-13.359,1.597-19.321l-22.91-32.095c10.562-17.622,18.413-36.519,23.408-56.411l39.848-6.475&#xD;&#xA;&#x9;&#x9;&#x9;C506.697,299.594,512,293.339,512,286v-60C512,218.661,506.697,212.406,499.461,211.205z M256,421c-90.981,0-165-74.019-165-165&#xD;&#xA;&#x9;&#x9;&#x9;S165.019,91,256,91s165,74.019,165,165S346.981,421,256,421z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M325.29,297.732C308.773,317.866,284.017,331,256,331c-28.017,0-52.773-13.134-69.291-33.268&#xD;&#xA;&#x9;&#x9;&#x9;c-14.379,12.744-24.868,29.451-30.654,48.197C180.784,373.387,216.224,391,256,391s75.216-17.613,99.944-45.071&#xD;&#xA;&#x9;&#x9;&#x9;C350.158,327.183,339.67,310.476,325.29,297.732z"/>
			</g>
		</g>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
		<g/>
	</svg>
	);


// WEBPACK FOOTER //
// ./src/components/sidebar/iconsvgs/skills.js